import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import "dayjs/locale/nl";

export function registerDefaults() {
	dayjs.extend(customParseFormat);
	dayjs.locale("nl");
}
